import { size, find, mapValues, map } from 'lodash';
import { stateGo } from 'redux-ui-router';
import { memberStorage } from 'utils';
import { fetchFavouriteRecipes, selectFavouriteRecipes } from 'logic/favourite';

import {
  selectMember,
  selectMemberLevel,
  selectIsProductLowFodmap,
  selectIsProductWithRequirements,
} from 'logic/member';

import {
  updateFilters,
  fetchFiltersRecipes,
  selectSortByRecipes,
  selectFiltersRecipesChecked,
  selectFiltersRecipesGrouped,
  toggleFiltersIsActive,
} from 'logic/filters';

import {
  createMeal,
  deleteMeal,
  fetchMealPlan,
  selectDays,
  selectRecipes,
  swapRemove,
} from 'logic/mealPlan';

import {
  resetSearch,
  searchRecipes,
  selectSearchPagination,
  selectSearchParams,
  selectSearchResults,
} from 'logic/search';

export const MealPlanEdit = {
  template: `
    <div class="meal-plan-edit">
      <div class="overlay bg-gray-100">
        <nav-fullscreen
          title="'Add Meal'"
          on-click="$ctrl.onDone($ctrl.mealPlanId)">
        </nav-fullscreen>
        <div class="container">
          <div class="row">
            <div class="col-2 col-md-3 px-0 pl-md-1">
              <meal-plan-days
                day="$ctrl.day"
                days="$ctrl.days"
                is-swapping="$ctrl.isSwapping"
                is-swapping-day="$ctrl.isSwappingDay"
                on-update="$ctrl.onUpdateParam('day', dayString)"
                on-remove="$ctrl.deleteMeal($ctrl.mealPlanId, mealId, day)">
              </meal-plan-days>
            </div>
            <div class="col-10 col-md-9">
              <div class="row">
                <div class="col-md-8 px-0 px-md-3 bg-white">
                  <div class="d-flex d-md-none p-2 p-md-3 border border-bottom">
                    <button class="btn btn-link p-0"
                      type="button"
                      ng-click="$ctrl.toggleFiltersIsActive()">
                      <i class="fa fa-2x fa-sliders"></i>
                    </button>
                    <button class="btn btn-link p-0 ml-3"
                      type="button"
                      ng-click="$ctrl.onToggleFavourites()">
                      <i class="fa fa-2x icon-favourites"
                        ng-class="{ 'text-teal-dark': $ctrl.isFavourites }">
                      </i>
                    </button>
                    <search-form
                      class="d-inline-flex ml-auto"
                      placeholder="find recipes"
                      query="$ctrl.params.q"
                      on-submit="$ctrl.onUpdateParam('q', query)">
                    </search-form>
                  </div>
                  <div class="pl-2 p-md-0">
                    <div class="alert alert-warning mt-3 mb-0"
                      ng-if="$ctrl.isProductRequirements">
                      Please be aware that if you choose to swap recipes into your plan, they may not be suitable for
                      {{ $ctrl.isProductLowFodmap ? "Low FODMAP" : "your Program's" }}
                      dietary requirements, and you will need to adapt ingredients accordingly.
                    </div>
                    <search-filter-results
                      query="$ctrl.search.params.q"
                      filters="$ctrl.checkedFilters"
                      on-clear-all="$ctrl.onClearAll()"
                      on-update-param="$ctrl.onUpdateParam(key, value)"
                      on-update-filter="$ctrl.onUpdateFilter(item, type, key)">
                    </search-filter-results>
                    <search-results
                      on-update-param="$ctrl.onUpdateParam(key, value)"
                      order="$ctrl.sortBy"
                      pagination="$ctrl.pagination"
                      type="recipes">
                      <div class="border border-bottom w-100"></div>
                      <div class="meal-plan-recipe-row recipe-row-sm"
                        ng-repeat="recipe in $ctrl.results track by $index">
                        <meal-plan-serves
                          recipe="recipe"
                          on-add-recipe="$ctrl.createMeal(
                            $ctrl.dayKey,
                            $ctrl.mealPlanId,
                            recipeId,
                            leftOvers
                          ); $ctrl.active = undefined"
                          on-close="$ctrl.active = undefined"
                          ng-show="$ctrl.active === recipe.id">
                        </meal-plan-serves>
                        <recipe-row
                          recipe="recipe"
                          on-preview="$ctrl.onPreview(recipe)">
                          <button class="btn btn-link p-0"
                            ng-click="$ctrl.active = recipe.id">
                            <i class="fa fa-2x fa-plus-circle"></i>
                          </button>
                        </recipe-row>
                      </div>
                    </search-results>
                  </div>
                </div>
                <div class="col-md-4 pt-3">
                  <nav-mobile-sidebar
                    heading="Filter"
                    is-active="$ctrl.filtersIsActive"
                    on-click="$ctrl.toggleFiltersIsActive()">
                    <div class="d-none d-md-block">
                      <div class="border border-bottom pb-3">
                        <search-form
                          placeholder="find recipes"
                          query="$ctrl.params.q"
                          on-submit="$ctrl.onUpdateParam('q', query)">
                        </search-form>
                      </div>
                      <div class="d-flex justify-content-between align-items-center border border-bottom p-2 mb-2">
                        Favourites
                        <button class="btn btn-link p-0 border-0"
                          type="button"
                          ng-click="$ctrl.onToggleFavourites()">
                          <i class="fa fa-2x mr-0" ng-class="{
                            'fa-toggle-on': $ctrl.isFavourites,
                            'fa-toggle-off': !$ctrl.isFavourites
                          }"></i>
                        </button>
                      </div>
                    </div>
                    <search-filter-recipes
                      filters="$ctrl.filters"
                      on-click="$ctrl.onUpdateFilter(item, type, key, list)">
                    </search-filter-recipes>
                  </nav-mobile-sidebar>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <recipe-preview
        recipe-id="$ctrl.previewId"
        show-on="$ctrl.previewShow">
      </recipe-preview>
      <meal-plan-help
        ng-if="$ctrl.showHelpModal">
      </meal-plan-help>
    </div>`,

  controller($ngRedux, $state, $timeout) {
    'ngInject';

    const EMPTY_PARAMS = {
      page: undefined,
      filters: undefined,
      order: undefined,
      q: undefined,
      serves: undefined,
    };

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        const { filters, router } = $ngRedux.getState();
        const { currentParams } = router;
        const { mealPlanHelpModal } = memberStorage.get();

        // Search for recipes using the current route params.
        this.isFavourites
          ? this.fetchFavouriteRecipes({
              ...currentParams,
              memberId: this.member.id,
            })
          : this.searchRecipes(currentParams);

        // Fetch mealPlans
        if (!this.days.length) {
          this.fetchMealPlan(this.mealPlanId, this.level);
        }

        // Fetch filters
        if (!filters.recipes.length) {
          this.fetchFiltersRecipes();
        }

        // Hide mobile sidebar
        this.showMobileSidebar = false;

        // Show or hide Help Modal
        if (!mealPlanHelpModal) {
          this.showHelpModal = true;
          memberStorage.setKey('mealPlanHelpModal', true);
        }
      },

      $onDestroy() {
        this.disconnect();
      },

      onToggleFavourites() {
        const pathKey = this.getPathKey('edit');
        const { level, order, page } = this.params;
        const favourites = this.isFavourites ? undefined : true;

        if (favourites) {
          this.fetchFavouriteRecipes({
            ...this.params,
            memberId: this.member.id,
          });
        }

        this.stateGo(pathKey, {
          ...EMPTY_PARAMS,
          day: this.day,
          level,
          page: 1,
          favourites,
        });
      },

      onUpdateFilter(item, type, key, list = []) {
        this.onUpdateParam(
          key,
          updateFilters(item.id, type, this.params[key], list)
        );
      },

      onUpdateParam(key, value = '') {
        const pathKey = this.getPathKey('edit');
        const page =
          value !== this.params[key] || key === 'q'
            ? undefined
            : this.params.page;

        this.stateGo(pathKey, {
          ...this.params,
          page,
          level: this.level,
          [key]: value,
        });
      },

      onClearAll() {
        this.stateGo(this.getPathKey('edit'), EMPTY_PARAMS);
      },

      onDone(mealPlanId) {
        this.resetSearch();

        // TODO: do a hard redirect to edit, due to some issues with the state
        // updating and a race condition.
        window.location.assign(
          $state.href(this.getPathKey(), { ...EMPTY_PARAMS, mealPlanId })
        );

        // this.stateGo(this.getPathKey(), { ...EMPTY_PARAMS, mealPlanId });
      },

      onPreview(recipe) {
        this.previewId = recipe.id;
        this.previewShow = true;
        $timeout(() => (this.previewShow = false));
      },

      getPathKey(append) {
        const { weekNumber } = $ngRedux.getState().router.currentParams;
        const parts = weekNumber
          ? ['program', 'week', 'mealPlan']
          : ['nutrition', 'mealPlans', 'detail'];

        if (append) {
          parts.push(append);
        }

        return parts.join('.');
      },

      mapState(state) {
        const {
          favourite,
          filters,
          mealPlan,
          member,
          router,
          recipe,
          search,
        } = state;

        const {
          day,
          favourites,
          mealPlanId,
          order,
          page,
          serves,
          voomeProductId,
        } = router.currentParams;

        const filterParams = router.currentParams.filters;
        const { isSwapping, isSwappingDay } = mealPlan;
        const days = selectDays(mealPlan, mealPlanId);
        const dayKey = (find(days, { dayString: day }) || {}).day;
        const isFavourites = favourites === 'true';
        const level = selectMemberLevel(member);

        const pagination = isFavourites
          ? selectFavouriteRecipes(favourite, { page, level, order })
          : selectSearchPagination(search);

        const results = isFavourites
          ? pagination.result
          : selectSearchResults(search);

        return {
          day,
          days,
          dayKey,
          isFavourites,
          isSwapping,
          isSwappingDay,
          level,
          mealPlanId,
          pagination,
          results,
          search,
          member: selectMember(member),
          isProductLowFodmap: selectIsProductLowFodmap(member, voomeProductId),
          isProductRequirements: selectIsProductWithRequirements(
            member,
            voomeProductId
          ),

          // Search
          filters: selectFiltersRecipesGrouped(filters, filterParams, serves),
          filtersIsActive: filters.isActive,
          checkedFilters: selectFiltersRecipesChecked(
            filters,
            filterParams,
            serves
          ),
          sortBy: selectSortByRecipes(filters, order),
          params: selectSearchParams(search),
        };
      },

      mapDispatch() {
        return {
          createMeal,
          deleteMeal,
          fetchFavouriteRecipes,
          fetchFiltersRecipes,
          fetchMealPlan,
          resetSearch,
          searchRecipes,
          stateGo,
          swapRemove,
          toggleFiltersIsActive,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/MealPlanEdit.js